export function getTimestamp() {
  const date = new Date(Date.now());
  return `${date.getMinutes()}m${date.getSeconds()}s${date.getMilliseconds()}ms`;
}
